import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getFinancialList } from "../../redux/InwardIteraction/actions";
import XmlSection2 from "../XmlViewer/XmlViewer2";

const FinancialInstitutionList = (props) => {
  const {
    goToNameEnquiry,
    goToAccountBlock,
    financialInstitutionList,
    getFinancialList,
    isLoading,
  } = props;

  useEffect(() => {
    getFinancialList();
  },
  // eslint-disable-next-line
  [getFinancialList]);

  const request = financialInstitutionList && financialInstitutionList.request;
  const response =
    financialInstitutionList && financialInstitutionList.response;

  return (
    <div className="inward-xml-wrap">
      <div className="inward-xml-wrap-header">
        <div
          className="nip-home-interaction-env-left-back"
          onClick={goToAccountBlock}
        >
          <p>{"<"}</p> &nbsp;
          <span>Back</span>
        </div>
        <div className="inward-xml-wrap-header-title">
          Financial Institution List
        </div>
        <div className="inward-xml-wrap-header-title2">
          Run tests, requests and responses, make API Calls and perform other
          related activities.
        </div>
      </div>
      <XmlSection2
        request={request}
        response={response}
        url={"api.nibss.com/transaction/initialize"}
        isLoading={isLoading}
      />
      <div className="retry-btn2">
        <button
          className="button-next2"
          type="button"
          onClick={goToNameEnquiry}
        >
          Next
        </button>
      </div>
    </div>
  );
};

FinancialInstitutionList.propTypes = {
  financialInstitutionList: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
  getFinancialList: PropTypes.func,
  goToAccountBlock: PropTypes.func,
  goToNameEnquiry: PropTypes.func,
  isLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendFinancialInstitutionListSuccess:
      state.inwardInteraction.getFinancialListSuccess,
    financialInstitutionList: state.inwardInteraction.getFinancialList,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getFinancialList: () => dispatch(getFinancialList()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinancialInstitutionList);
